import { InjectionToken } from '@angular/core';

export type IAuthorizationHeader = {
  context: { headers: { Authorization: string } };
};

export const AUTHORIZATION_HEADER_PROVIDER = new InjectionToken<AuthorizationHeaderProvider>(
  'AUTHORIZATION_HEADER_PROVIDER',
);

export interface AuthorizationHeaderProvider {
  get orderAuthHeader(): IAuthorizationHeader | undefined;
  get userAuthHeader(): IAuthorizationHeader | undefined;
}
